import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=6feace67&scoped=true&"
import script from "./Snackbar.vue?vue&type=script&lang=ts&"
export * from "./Snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=6feace67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feace67",
  null
  
)

export default component.exports